// import { ImagePreview } from 'vant'
import {
  queryTimeList,
  queryCourseData,
  queryTerritoryData,
  queryArgsToId,
  queryIdToArgs,
  queryAiHub
} from '../../api/index.js'
import axios from 'axios'
import merge from 'webpack-merge'

export default {
  name: 'detail-page',
  data () {
    return {
      timeList: [],
      currentPage: 1,
      allPage: 1,
      dataList: [],
      loading: false,
      finished: false,
      tabList: [], // tab栏
      peopleList: [{ name: '全部', value: null }, { name: '大学生', value: 1 }, { name: '高中生', value: 2 }],
      typeList: [{ name: '全部', value: '' }, { name: '海外小组科研', value: '1' }, { name: 'AI HUB', value: '5' }, { name: '国内小组科研', value: '6' }, { name: '全球华人导师', value: '32' }],
      countryList: [
        { name: '全部', value: null },
        { name: '美国', value: '美国' },
        { name: '英国', value: '英国' },
        { name: '其他', value: '其他' }
      ],
      optionList: [
        { name: '北京', value: '北京', realValue: ['北京', '北京外国语大学国际会议中心', '北京海淀凯文学校', '北京市新英才学校', '北京爱迪学校'] },
        { name: '深圳', value: '深圳', realValue: ['深圳市华朗学校', '深圳', '深圳虚拟大学园·国家大学科技园', '深圳国际预科书院'] }
        // { name: '广深', value: '广深', realValue: ['广深'] }
        // 2023-05-18 一个关键词对应多个查询条件
        // { name: '上海', value: '上海', realValue: ['上海知名国际学校', '上海交通大学·长宁校区', '复旦大学·生命科学创新实践基地'] },
        // { name: '深圳', value: '深圳', realValue: ['深圳知名国际学校'] },
        // { name: '长春', value: '长春', realValue: ['长春知名高校'] },
        // { name: '广州', value: '广州', realValue: ['广州', '广州知名中学'] },
        // { name: '成都', value: '成都', realValue: ['四川大学·望江校区'] },
        // { name: '武汉', value: '武汉', realValue: ['武汉英中高级中学-古田校区'] },
        // { name: '广州', value: '广州' },
        // { name: '哥伦比亚大学', value: '哥伦比亚大学', realValue: ['哥伦比亚大学'] },
        // { name: '剑桥大学', value: '剑桥大学', realValue: ['剑桥大学'] },
        // { name: '牛津大学', value: '牛津大学', realValue: ['牛津大学'] }
      ],
      optionList1: [
        { name: '北京', value: '北京', realValue: ['北京', '北京外国语大学国际会议中心', '北京海淀凯文学校', '北京市新英才学校', '北京爱迪学校'] },
        { name: '上海', value: '上海', realValue: ['上海', '上海圣华紫竹学院', '上海闵行区诺达双语学校'] },
        { name: '深圳', value: '深圳', realValue: ['深圳市华朗学校', '深圳', '深圳虚拟大学园·国家大学科技园', '深圳国际预科书院'] },
        { name: '中国香港', value: '中国香港', realValue: ['香港珠海学院'] },
        { name: '哥伦比亚大学', value: '哥伦比亚大学', realValue: ['哥伦比亚大学'] },
        { name: '剑桥大学', value: '剑桥大学', realValue: ['剑桥大学'] },
        { name: '牛津大学', value: '牛津大学', realValue: ['牛津大学'] }
      ],
      tabStrList: ['学科', '年级', '导师国家', '营地地点', '开课时间', '课程模式'],
      classTypeList: ['在线', '线下'],
      showtab: null,
      imgBig: '',
      imgBigShow: false,
      tabActive: null,
      valueName: null,
      dialogCheckParentData: [],
      dialogCheckData1: [],
      dialogCheckData2: null,
      dialogCheckData3: null,
      dialogCheckData5: null,
      dialogCheckData6: [],
      dialogCheckData7: [],
      dialogCheckData8: null,
      activeTerritoryindex: 0, // 学科搜索一级高亮
      activeTerritory1index: 0, // 学科搜索二级高亮
      activeTerritory2index: 0, // 学科搜索三级高亮
      territoryDataList: [], // 学科搜索
      territoryChildrenDataList: [],
      territoryChildrenThreeDataList: [],
      outLevel1: [],
      debounceInput: () => { },
      staticLevelMap: {
        1: { id: 7, type: '2', name: '金融商科', profession: [] },
        2: { id: 11, type: '2', name: '理工', profession: [] },
        3: { id: 17, type: '2', name: '人文社科', profession: [] },
        6: { id: 33, type: '2', name: '计算机与人工智能', profession: [] }
      },
      righCheckedList: [],
      imgList: [],
      isAiHub: false,
      is1v1: false,
      indexActive: null,
      ihubTimeList: [{ name: '2024寒假(1月28日入营)', value: '2024-01-12' }, { name: '2024暑期(7月14日入营)', value: '2024-07-06' }, { name: '2024暑期(7月28日入营)', value: '2024-07-20' }]
    }
  },
  watch: {
    // 已选数据监听
    territoryChildrenThreeDataList: {
      handler (newval, oldval) {
        let num = 0 // 已选中数据
        if (newval && newval.profession && newval.profession.length) {
          newval.profession.forEach(item2 => {
            if (item2.checked) {
              num++
            }
          })
          this.territoryChildrenDataList.profession.forEach(item1 => {
            if (item1.id === this.territoryChildrenThreeDataList.id) {
              this.$set(item1, 'num', num)
            }
          })
        }
      },
      immediate: true,
      deep: true
    },
    // 选中学科展示
    territoryDataList: {
      handler (newval, oldval) {
        this.tab0StrChange()
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.setWXShareInfo()
    // 默认学科查询 字段
    this.dialogCheckParentData = []
    // 如果是从首页跳转过来的和老数据的分享level1bug
    if (Number(this.$route.query.level1) === 7) {
      this.isAiHub = true
    }
    if (Number(this.$route.query.level1) === 99 || Number(this.$route.query.level1) === 8) {
      if (Number(this.$route.query.level1) === 8) {
        this.is1v1 = true
      }
      this.showtab = false
    } else {
      this.showtab = true
    }
    this.$route.query.level1 = JSON.stringify([this.$route.query.level1])
    if (this.$route.query && this.$route.query.level1 && this.$route.query.level1.length > 0) {
      this.outLevel1 = JSON.parse(this.$route.query.level1)
      // 拿出对应的位置信息
      for (const outItem of this.outLevel1) {
        const checkStaticItem = this.staticLevelMap[outItem]
        if (!checkStaticItem) {
          continue
        }
        this.dialogCheckParentData.push(checkStaticItem)
      }
      this.$route.query.level1 = null
    }
    // 获取时间选项
    this.getTimeList()
    // 搜索列表数据
    this.getTerritoryData()
  },
  mounted () {
    window.scrollTo(0, 0)
    this.debounceInput = this.debounce(this.querySure, 500, false)
    // if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
    //   document.addEventListener('WeixinJSBridgeReady', this.ready(), false)
    // } else {
    //   this.ready()
    // }
  },
  methods: {
    ready () {
      // alert(window.__wxjs_environment === 'miniprogram')
      console.log(window.__wxjs_environment === 'miniprogram') // true
    },
    goHome () {
      this.$router.push({ path: '/' })
    },
    downloads (url) {
      const wx = this.$wx
      const fileName = new Date().valueOf()
      const filePath = wx.env.USER_DATA_PATH + '/' + fileName + '.jpg'
      wx.downloadFile({
        url: url,
        filePath: filePath,
        success: function (res) {
          alert(url)
          wx.saveImageToPhotosAlbum({
            filePath: filePath,
            success: function (data) {
              const fileMgr = wx.getFileSystemManager()
              fileMgr.unlink({
                filePath: filePath,
                success () {
                  wx.showToast({
                    title: '已保存至您的相册',
                    icon: 'none',
                    duration: 1500
                  })
                }
              })
              // }
            }
          })
        },
        fail: function (err) {
          alert(111)
          console.log(err, 'err2222')
          // reject(err)
        }
      })
    },
    // 样式换行
    getLine (index) {
      this.$nextTick(() => {
        const noticeDom = this.$refs[index][0]
        const notice1 = noticeDom.parentNode.nextSibling.firstElementChild
        const style = window.getComputedStyle(noticeDom, null)
        const style1 = window.getComputedStyle(notice1, null)
        const row = Math.floor(
          Number(style.height.replace('px', '')) /
          Number(style.lineHeight.replace('px', ''))
        )
        const row1 = Math.floor(
          Number(style1.height.replace('px', '')) /
          Number(style1.lineHeight.replace('px', ''))
        )
        if (row >= 4) {
          noticeDom.style.cssText = 'line-clamp:4;-webkit-line-clamp:4'
          notice1.style.cssText = 'line-clamp:2;-webkit-line-clamp:2'
        }
        if (row1 > 3) {
          notice1.style.cssText = 'line-clamp:3;-webkit-line-clamp:3'
        }
      })
    },
    debounce (func, delay = 800, immediate = false) {
      let timer = null
      // 不能用箭头函数
      return function () {
        // 在时间内重复调用的时候需要清空之前的定时任务
        if (timer) {
          clearTimeout(timer)
        }
        // 适用于首次需要立刻执行的
        if (immediate && !timer) {
          func.apply(this, arguments)
        }
        timer = setTimeout(() => {
          func.apply(this, arguments)
        }, delay)
      }
    },
    async clicktab (type, index) {
      this.tabActive = type
      this.indexActive = index
    },
    async resetDialog (type) {
      // 重制路由内容
      if (type === 1) {
        this.dialogCheckParentData = []
        // 初始化
        this.territoryDataList.forEach(item => {
          this.$set(item, 'checked', false)
          this.childrenUncheck(item)
        })
        this.indexActive = null
      } else if (type === 2) {
        this.dialogCheckData1 = []
        this.dialogCheckData7 = []
      } else if (type === 4) {
        this.dialogCheckData3 = null
        // 替换路由参数
        this.$router.push({
          query: merge({}, { level1: this.$route.query.level1 })
        })
      } else if (type === 5) {
        this.dialogCheckData5 = null
      } else if (type === 6) {
        this.dialogCheckData6 = []
      } else if (type === 7) {
        this.dialogCheckData8 = null
      }
      this.dataList = []
      await this.querySure()
    },

    // 递归搜索列表选中的数据
    async getTerritoryDataList () {
      const list = JSON.parse(JSON.stringify(this.territoryDataList))
      let newList = []
      if (list.length > 0) {
        if (list[0].checked) { // 选全部则传【】数组；
          this.dialogCheckParentData = []
          return
        } else {
          newList = list.filter(item => item.checked)
        }
      }

      await this.getDataList(newList)
      this.dialogCheckParentData = newList
    },
    // 递归获取搜索列表的levelList
    async getDataList (newList) {
      newList.forEach(item => {
        if (item.profession && item.profession.length) {
          let newList1 = []
          let threeDataIndex = null
          threeDataIndex = item.profession.findIndex((item1, index) => item1.checked && !item1.type && item1.id === -1)
          if (threeDataIndex > -1) {
            var newArr = item.profession.filter((val, index, arr) => {
              return index !== threeDataIndex
            })
            item.profession = newArr
          } else {
            newList1 = item.profession.filter(item1 => item1.checked)
            item.profession = newList1
            this.getDataList(item.profession)
          }
        }
      })
    },
    async querySure (type) {
      this.finished = false
      this.tabActive = null
      this.indexActive = null
      this.loading = true
      this.dataList = []
      this.currentPage = 1
      this.allPage = 1
      if (type && type === 4) {
        this.$router.replace({
          query: merge(this.$route.query, { suggest: this.dialogCheckData3.value })
        })
      }
      if (type) {
        this.dataList = []
      }
      await this.getTerritoryDataList()
      await this.getAllDataOnSearch(1)
      this.loading = false
    },
    // 搜索列表接口数据
    async getTerritoryData () {
      const result = await queryTerritoryData({ isLevel3: true })
      // 一级加全部
      this.territoryDataList = [{ name: '全部', id: 0, profession: [] }]
      //  二级加全部
      result.data.direction.forEach((item) => {
        item.profession.unshift({ name: '全部', id: -1 })
        item.profession.forEach((item1) => {
          if (item1.profession) {
            // 三级,加全部
            item1.profession.unshift({ name: '全部', id: -1 })
          }
        })
      })
      const list = result.data.direction
      // 菜单数组
      this.territoryDataList = [...this.territoryDataList, ...list]
      // 学科根据路由默认选中菜单。
      await this.flat(this.dialogCheckParentData)
      await this.getLevelList(this.territoryDataList)
      // 默认选中第一个选中的数据
      const index = this.territoryDataList.findIndex(item => item.checked)
      if (index > -1) {
        const item = this.territoryDataList.find(item => item.checked)
        this.getChildrenData(item, index, 1) // 一级点击事件
        const index1 = item.profession.findIndex(item1 => item1.checked)
        if (index1 > -1) {
          const item1 = item.profession.find(item1 => item1.checked)
          this.getChildrenData(item1, index1, 2) // 二级点击事件
          const index2 = item1.profession && item1.profession.findIndex(item2 => item2.checked)
          if (index2 > -1) {
            const item2 = item1.profession.find(item2 => item2.checked)
            this.getChildrenData(item2, index2, 3) // 二级点击事件
          }
        } else {

        }
      } else {

      }
    },
    // 扁平化选中的学科搜索数据
    async flat (arr) {
      // 验证arr数组中，还有没有深层数组[1,2,[3,4]]
      arr.forEach(item => {
        if (item.profession && Array.isArray(item.profession)) {
          this.dialogCheckParentData = this.dialogCheckParentData.concat(...item.profession)
          this.flat(item.profession)
        }
      })
    },
    // 默认选中的学科列表高亮和选中
    getLevelList (list) {
      list.forEach((item, index) => {
        if (this.dialogCheckParentData.find(item1 => item1.id === item.id)) {
          this.$set(item, 'checked', true)
          if (item.profession && item.profession.length) {
            this.getLevelList(item.profession)
          }
        }
      })
    },
    // 菜单高亮
    checkLevel1Class (index, currentIndex) { // 菜单高亮
      return currentIndex === index
    },
    // 已选数据过滤
    checkLeve2Class (list) { // 二级菜单已选背景class
      if (list.profession) {
        let num = 0
        list.profession.forEach(item => {
          if (item.checked) {
            num += num
          }
        })
        return '（已选' + num + ')'
      }
    },
    // 全选，全不选重构
    checkAllOrNoCheck (item, indextype, type, list) {
      // [item]当前菜单， 【indextype】点击索引，【type】点击的菜单，
      if (indextype === 0) { // 点击选择全部全选中
        this.$set(item, 'checked', !item.checked)
        list.forEach(item1 => {
          this.$set(item1, 'checked', item.checked)
        })
      } else { // 选择下面非全部菜单
        this.$set(item, 'checked', !item.checked)
        this.$nextTick(() => {
          if (list.findIndex(item => item.checked === false) > -1) {
            this.$set(list[0], 'checked', false)
          } else {
            // 选下面则全部自动选中
            let ArrList = []
            ArrList = list.filter((val, index, arr) => {
              return index !== 0
            })
            if (ArrList.every((item) => item.checked === true)) {
              this.$set(list[0], 'checked', true)
            }
          }
        })
      }
      // 选中当前取消选中它所有的子集。
      this.childrenUncheck(item)
      // 当前选择的二级数据， 当前索引，1级菜单/2级菜单 ， 原始list
      this.getChildrenData(item, indextype, type)
    },
    // 点击菜单获取下一级数据
    getChildrenData (item, indextype, type) {
      if (type === 1) { // 点击的是一级菜单逻辑处理
        this.activeTerritoryindex = indextype // 当前选择了哪个一级菜单
        this.territoryChildrenDataList = item // 一级菜单下二级里的内容是什么
        // 自动点击二级获取三级数据
        if (indextype !== 0) {
          this.nextCheckedperChecked(this.territoryChildrenDataList.profession[0], 0, 2)
        } else { // 点击全部
          this.territoryChildrenThreeDataList = []
        }
      } else if (type === 2) { // 点击的是二级菜单逻辑处理
        this.nextCheckedperChecked(item, indextype, type)
      } else if (type === 3) { // 点击的是三级菜单逻辑处理
        this.nextCheckedperChecked(item, indextype, type)
      }
    },
    // 点击下一级选中，上一级自动选中。
    nextCheckedperChecked (item, indextype, type) {
      // 点击二级自动选中一级
      if (type === 2) {
        this.activeTerritory1index = indextype // 二级搜索高亮
        this.territoryChildrenThreeDataList = item // 三级菜单数据内容
        if (item.checked) { // 选中绑定上一级选中
          this.territoryDataList.forEach(item1 => {
            if (item1.id === this.territoryChildrenDataList.id) {
              this.$set(item1, 'checked', true)
            }
          })
        }
      }
      // 点击三级自动选二级,并计算二级选中数据
      if (type === 3) {
        this.activeTerritory2index = indextype // 三级搜索高亮
        // 自动选中上一级
        if (item.checked) {
          this.territoryChildrenDataList.profession.forEach(item1 => {
            if (item1.id === this.territoryChildrenThreeDataList.id) {
              this.$set(item1, 'checked', true)
            }
          })
        }
      }
    },
    // 递归，当前取消它下面所有children则取消
    childrenUncheck (item) {
      if (!item.checked && item.profession && item.profession.length) {
        this.$set(item, 'num', 0)
        item.profession.forEach(item1 => {
          this.$set(item1, 'checked', false)
          this.childrenUncheck(item1)
        })
      }
    },
    // 显示当前选中的学科
    async tab0StrChange () {
      const list = this.territoryDataList.filter(item => item.checked && item.id !== 0)
      const strArr = list.map(item => item.name)
      if (strArr.length > 0 && list.length !== this.territoryDataList.length - 1) {
        const str = strArr.join(',')
        this.tabStrList[0] = str
      } else {
        this.tabStrList[0] = '学科'
      }
    },
    async clickDialog1 (item1, item) {
      const typeitem = item.year + '-' + item1
      const index = this.dialogCheckData1.findIndex(item1 => item1 === typeitem)
      if (index > -1) {
        this.dialogCheckData1.splice(index, 1)
      } else {
        this.dialogCheckData1.push(typeitem)
      }
    },
    clickDialogtime (item) {
      const index = this.dialogCheckData7.findIndex(item1 => item1 === item.value)
      if (index > -1) {
        this.dialogCheckData7.splice(index, 1)
      } else {
        this.dialogCheckData7.push(item.value)
      }
    },
    async clickDialog2 (item, index) {
      this.dialogCheckData2 = item
    },
    async closeOverlay (type) {
      this.tabActive = null
    },
    async clickDialog3 (item) {
      this.dialogCheckData3 = item
    },
    async clickDialog5 (item) {
      this.dialogCheckData5 = item.value
    },
    async clickDialog6 (item) {
      const index = this.dialogCheckData6.findIndex(item1 => item1 === item.value)
      if (index > -1) {
        this.dialogCheckData6.splice(index, 1)
      } else {
        this.dialogCheckData6.push(item.value)
      }
    },
    async clickDialog7 (item) {
      this.dialogCheckData8 = item
    },
    async getTimeList () {
      const timeList = await queryTimeList({})
      this.timeList = timeList.data
    },

    async getAllDataOnSearch (type) {
      const args = await this.getArgs(type)
      await this.getAllData(args)
    },
    async getArgs (type) {
      if (this.$route.query.name) {
        this.valueName = this.$route.query.name
        this.$route.query.name = null
      }
      const realP = []
      this.dialogCheckData6.forEach(item => {
        const obj = this.optionList.find(item1 => item1.value === item)
        const obj1 = this.optionList1.find(item1 => item1.value === item)
        if (obj) {
          realP.push(...obj.realValue)
          if (obj1 && obj.value && obj1.value) {
            return
          }
        }
        if (obj1) {
          realP.push(...obj1.realValue)
        }
      })
      const args = {
        suggest: this.dialogCheckData3 ? this.dialogCheckData3.value : null,
        limit: 20,
        page: this.currentPage,
        name: this.valueName,
        isAiHub: this.isAiHub,
        levelList: this.dialogCheckParentData,
        add7Day: true,
        teacherCountry: this.dialogCheckData5 ? this.dialogCheckData5 : null,
        time: this.dialogCheckData1,
        schoolBegins: this.dialogCheckData7,
        position: realP,
        showtab: this.showtab,
        courseMode: this.dialogCheckData8
      }
      if (this.isAiHub) {
        args.typeId = 38
        args.typeIdList = [5, 38]
      } else {
        // 新增菜单逻辑
        if (this.showtab) {
          if (this.dialogCheckData8) {
            args.typeIdList = this.dialogCheckData8 === '在线' ? [1] : [38]
          } else {
            args.typeIdList = [1, 5, 38]
          }
        } else {
          if (this.is1v1) {
            args.typeIdList = [56]
          } else {
            args.typeIdList = [49]
          }
          // args.typeId = 38
        }
      }
      // 如果没有ID去换取ID 如果是搜索时候要重新获取id
      if (!this.$route.query.id || type === 1 || this.currentPage !== 1) {
        args.page = 1 // 传入后台1
        const result = await queryArgsToId({ args: args })
        this.$router.replace({ query: merge(this.$route.query, { id: result.data.id }) })
        // 调用列表数据传正常
        args.page = this.currentPage
        return args
      } else if (this.$route.query.id) {
        // this.$router.replace({ query: merge(this.$route.query, { id: idRes.data.id }) })
        const result = await queryIdToArgs({ id: this.$route.query.id })
        // 第一次记录的参数
        if (result && result.data && result.data.args) {
          this.initData(result.data.args)
          if (result.data.args.isAiHub) {
            result.data.args.typeId = 38
          }
          return result.data.args
        } else {
          return args
        }
      }
    },
    async initData (myargsObj) {
      // 如果是从连接跳转过来的有搜索默认数据
      if (myargsObj.name) {
        this.valueName = myargsObj.name
      }
      if (myargsObj.levelList) {
        this.dialogCheckParentData = myargsObj.levelList
      }
      if (myargsObj.name) {
        this.valueName = myargsObj.name
      }
      if (myargsObj.suggest) {
        this.dialogCheckData3 = this.peopleList.find(item => item.value === Number(this.$route.query.suggest))
      }
      if (myargsObj.teacherCountry) {
        this.dialogCheckData5 = myargsObj.teacherCountry
      }
      if (myargsObj.time && myargsObj.time.length) {
        this.dialogCheckData1 = myargsObj.time
      }
      if (myargsObj.position && myargsObj.position.length) {
        this.dialogCheckData6 = myargsObj.position
      }
      if (myargsObj.schoolBegins) {
        this.dialogCheckData7 = myargsObj.schoolBegins
      }
      if (myargsObj.courseMode) {
        this.dialogCheckData8 = myargsObj.courseMode
      }
      this.showtab = myargsObj.showtab
    },
    async getAllDataOnFinish () {
      const args = await this.getArgs()
      await this.getAllData(args)
    },
    async getAllData (args) {
      // AIHUBjiek
      let list = []
      if (this.isAiHub || args.isAiHub) {
        this.isAiHub = true
        // args.teacherType = 2
        list = await queryAiHub(args)
      } else {
        list = await queryCourseData(args)
      }
      if (list.data && list.data.courseList.length === 0) {
        this.finished = true
        return
      }
      if (list.data.courseList.length > 0) {
        this.dataList = [...this.dataList, ...list.data.courseList]
      }
      this.allPage = list.data.allPage
      this.currentPage += 1
      this.loading = false
    },
    godetail (item) {
      if (item.isCanGoInfo) {
        const origin = window.location.origin
        if (process.env.NODE_ENV === 'development') {
          window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
        } else {
          if (origin.indexOf('-testserver') > -1) {
            window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
          } else {
            window.open('https://sou-m.gecacademy.cn/share?id=' + item.id)
          }
        }
      }
    },
    // 查看图片
    show_before_img (item) {
      this.imgBig = item
      this.imgBigShow = true
    },
    closeImgBig () {
      this.imgBig = ''
      this.imgBigShow = false
    },
    rightClick (item) {
      const index = this.righCheckedList.findIndex(item1 => item1.id === item.id)
      if (index > -1) {
        this.righCheckedList = this.righCheckedList.filter(item1 => { return item1.id !== item.id })
      } else {
        this.righCheckedList.push({ id: item.id, img: item.imageHeader, name: item.name })
      }
    },
    // 保存图片
    saveImg () {
      // this.setWXShareInfo()
      const wx = this.$wx
      wx.miniProgram.navigateTo({
        url: '/pages/saveImg/index?url=' + this.righCheckedList[0].img
      })
      // this.downloads(this.righCheckedList[0].img)
    },
    // 转发海报
    getShowTab (item) {
      if ((item !== '营地地点' && item !== '课程模式' && item !== '开课时间') && this.isAiHub) {
        return true
      }
      if (item !== '营地地点' && !this.isAiHub) {
        return true
      }
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://sou-tools.gecacademy.cn${currentRouter}`
      const shareTitle = 'Path Academics'
      const shareDesc = 'Light Your Path. Walk Your Way.'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/oa/upload/2021-04-30%2016-47-46-WechatIMG4292.jpeg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () { },
        cancel () { }
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'sou-tools'
      }
      // const signature = wxac72a16e964c725f
      // const result = await axios.get('https://api.gecacademy.cn/pay/wx/signature', {
      //   params
      // })
      // const signature = result.data.data
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: 'test',
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
      // //  jsapi_ticket
      // // const signature = result.data.data.signature
      // // const wx = this.$wx
      // wx.config({
      //   debug: false,
      //   appId: 'wxf88eda53c74e883f',
      //   timestamp,
      //   nonceStr: String(test),
      //   signature,
      //   jsApiList: [
      //     'chooseImage',
      //     'uploadImage',
      //     'addCard',
      //     'chooseCard',
      //     'openCard',
      //     'onMenuShareTimeline',
      //     'onMenuShareAppMessage',
      //     'updateAppMessageShareData',
      //     'updateTimelineShareData',
      //     'previewImage',
      //     'showMenuItems',
      //     'onMenuShareQQ',
      //     'onMenuShareWeibo'
      //   ]
      // })
      // wx.error(function (res) {
      //   // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
      // })
      // wx.checkJsApi({
      //   jsApiList: [
      //     'chooseImage',
      //     'uploadImage',
      //     'addCard',
      //     'chooseCard',
      //     'openCard',
      //     'onMenuShareTimeline',
      //     'onMenuShareAppMessage',
      //     'updateAppMessageShareData',
      //     'updateTimelineShareData',
      //     'previewImage',
      //     'showMenuItems',
      //     'onMenuShareQQ',
      //     'onMenuShareWeibo',
      //     'downloadImage'
      //   ], // 需要检测的 JS 接口列表，所有 JS 接口列表见附录2,
      //   success: function (res) {
      //   // 以键值对的形式返回，可用的 api 值true，不可用为false
      //   // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      //   }
      // })
      // wx.updateAppMessageShareData(shareInfo)
      // wx.onMenuShareTimeline(shareInfo)
      // wx.onMenuShareAppMessage(shareInfo)
      // wx.updateAppMessageShareData(shareInfo)
      // wx.updateTimelineShareData(shareInfo)
    }
  }
}
